import { z } from 'zod/v3';

export const ScanPhaseSchema = z.enum([
  'idle',
  'queued',
  'clone',
  'analysis',
  'complete',
  'failed',
  'skipped',
]);

export const ScanLevelSchema = z.enum([
  'pass',
  'warn',
  'fail',
  'info',
  'progress',
]);

export const ScanFindingEventDTOSchema = z.object({
  id: z.string(),
  seq: z.number().int().nonnegative(),
  phase: ScanPhaseSchema,
  level: ScanLevelSchema,
  message: z.string(),
  checkId: z.string().optional(),
  metadata: z.record(z.unknown()).optional(),
  timestamp: z.string(),
}).strict();

export const ScanFindingsResponseDTOSchema = z.object({
  runId: z.string().nullable(),
  phase: ScanPhaseSchema,
  percent: z.number().int().min(0).max(100),
  isTerminal: z.boolean(),
  findings: z.array(ScanFindingEventDTOSchema),
}).strict();

export type ScanPhase = z.infer<typeof ScanPhaseSchema>;
export type ScanLevel = z.infer<typeof ScanLevelSchema>;
export type ScanFindingEventDTO = z.infer<typeof ScanFindingEventDTOSchema>;
export type ScanFindingsResponseDTO = z.infer<typeof ScanFindingsResponseDTOSchema>;
